var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"6.22549","cy":"6.17139","rx":"5.98575","ry":"6","fill":"#F24424","key":0}),React.createElement("path",{"d":"M5.85199 4.93092V9.05472H6.59841V4.93092H5.85199ZM5.80859 4.16532H6.64181V3.28662H5.80859V4.16532Z","fill":"white","key":1})]);
}

Warning.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Warning;

Warning.default = Warning;
